// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileGifOutlinedSvg from "@ant-design/icons-svg/es/asn/FileGifOutlined";
import AntdIcon from '../components/AntdIcon';

var FileGifOutlined = function FileGifOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileGifOutlinedSvg
  }));
};

FileGifOutlined.displayName = 'FileGifOutlined';
export default React.forwardRef(FileGifOutlined);